<template>
  <div class="main-container">
    <div class="tools-box">
      <Button @click="backPage()" type="primary" ghost>返回</Button>
    </div>
    <Tabs v-model="tabVal" v-if="policyDetail">
      <TabPane label="投保信息" name="1"></TabPane>
      <!-- productCategory 1-团险 2-财产险 3、个险 -->
      <TabPane v-if="policyDetail.productCategory != 2" label="人员清单" name="2"> </TabPane>
      <TabPane v-if="policyDetail.productCategory != 2" label="保全信息" name="3"> </TabPane>
      <TabPane v-if="policyDetail.type == 1 || policyDetail.dockChannel == 3" label="发票信息" name="4"></TabPane>
      <TabPane label="服务费信息" name="5" v-if="$units.pointAction('order_50_14')"> </TabPane>
    </Tabs>
    <holderInfo v-if="tabVal == 1" :id="id" :operationFunction="operationFunction" @request-success="getHolderInfoData"></holderInfo>
    <insureList v-else-if="tabVal == 2 && policyDetail.productCategory != 2" :operationFunction="operationFunction" :policyDetail="policyDetail">
    </insureList>
    <peservationInfo v-else-if="tabVal == 3 && policyDetail.productCategory != 2" :operationFunction="operationFunction" :policyDetail="policyDetail"></peservationInfo>
    <invoiceInfo v-else-if="tabVal == 4" :invoiceUrl="policyDetail.invoiceUrl"></invoiceInfo>
    <commissionInfoNew v-else-if="tabVal == 5"></commissionInfoNew>
  </div>
</template>

<script>
var tabVal;
import { mapState } from 'vuex';
import { common } from '@/api/mixins';
import holderInfo from './components/holderInfo';
import insureList from './components/insureList';
import invoiceInfo from './components/invoiceInfo';
import commissionInfoNew from './components/commissionInfoNew';
import peservationInfo from './components/peservationInfo';

export default {
  components: {
    holderInfo,
    insureList,
    peservationInfo,
    commissionInfoNew,
    invoiceInfo
  },
  mixins: [common],
  computed: {
    ...mapState(['userInfo'])
  },
  data() {
    return {
      tabVal: '1',
      policyDetail: null,
      id: '',
      orderNo: '',
      policyNo: '',
      productCategory: '',
      invoiceUrl: '',
      operationFunction: ''
    };
  },
  beforeRouteEnter(to, from, next) {
    if (from.name == 'orderManage.group.invoiceList') {
      tabVal = '4';
    } else {
      tabVal = null;
    }
    next();
  },
  created() {
    this.id = this.$route.query.id;
    this.policyNo = this.$route.query.policyNo;
    this.orderNo = this.$route.query.orderNo;
    this.operationFunction = this.$route.query.operationFunction;
    //财险只显示三个标签  投保信息、发票信息、服务费信息
    this.tabVal = tabVal || this.tabVal;
  },
  methods: {
    backPage() {
      if (this.$route.query.workName == 'workName') {
        this.back('/workbench/index');
      } else if (this.$route.query.workName == 'insuredList') {
        this.back('/orderManage/group/insuredList');
      } else if (this.$route.query.workName == 'peservation') {
        this.back('/orderManage/group/peservation');
      } else if(this.$route.query.backUrl) {
        this.back(this.$route.query.backUrl);
      } else {
        this.back('/orderManage/group/policy');
      }
    },
    // 获取详情
    getHolderInfoData(data) {
      this.policyDetail = data;
    }
  }
};
</script>
<style lang="scss" scoped>
.tools-box {
  display: flex;
  justify-content: flex-end;
  position: absolute;
  right: 20px;
  z-index: 1;
}
</style>
